// extracted by mini-css-extract-plugin
export default {"mainCont":"ChangeTarif_mainCont__+P6hg","mfCont":"ChangeTarif_mfCont__vdW9s","mdMain":"ChangeTarif_mdMain__-oWOl"};